export default __webpack_public_path__ + "static/media/iris-play.bf294cac.png";